import { CaptchaActionsEnum } from '../enums/CaptchaActionsEnum';
import { ICaptchaState } from '../interfaces/ICaptchaState';
import { CaptchaAction } from '../types/CaptchaAction';

const initialState: ICaptchaState = {
  isFetching: false,
  error: null,
  captchaToken: localStorage.getItem('captcha'),
  isActive: false,
  image: '',
};

export function captchaReducer(state = initialState, action: CaptchaAction): ICaptchaState {
  switch (action.type) {
    case CaptchaActionsEnum.CAPTCHA_RESET: {
      return {
        ...state,
        image: initialState.image,
        audio: undefined,
      };
    }
    case CaptchaActionsEnum.CAPTCHA_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case CaptchaActionsEnum.CAPTCHA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        captchaToken: action.payload.token,
      };
    case CaptchaActionsEnum.CAPTCHA_SET_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload.error,
        captchaToken: '',
      };
    case CaptchaActionsEnum.CAPTCHA_SET_IS_ACTIVE: {
      return {
        ...state,
        isActive: action.payload.value,
      };
    }
    case CaptchaActionsEnum.CAPTCHA_SET_IMAGE: {
      return {
        ...state,
        image: action.payload.image,
      };
    }
    case CaptchaActionsEnum.CAPTCHA_SET_ACTION_AFTER_LOAD: {
      return {
        ...state,
        actionAfterTokenLoad: action.payload.func,
      };
    }
    case CaptchaActionsEnum.CAPTCHA_SET_AUDIO: {
      return {
        ...state,
        audio: action.payload.audio,
      };
    }
    default:
      return state;
  }
}
